import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = {
  key: 1,
  class: "form-group mb-3"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, " Your account was successfully created and an email has been sent with additional information. ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn back-btn btn-primary w-100",
  label: "Login to My Account",
  as: "router-link",
  to: "/"
}, null, -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 2,
  class: "form-group mb-3"
}
const _hoisted_7 = {
  for: "ssn",
  class: "form-label"
}
const _hoisted_8 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_9 = {
  key: 3,
  class: "form-group mb-3"
}
const _hoisted_10 = {
  for: "zip",
  class: "form-label"
}
const _hoisted_11 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_12 = {
  key: 4,
  class: "form-group mb-3"
}
const _hoisted_13 = {
  for: "dob",
  class: "form-label"
}
const _hoisted_14 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_15 = {
  key: 5,
  class: "form-group mb-3"
}
const _hoisted_16 = {
  for: "lastName",
  class: "form-label"
}
const _hoisted_17 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_18 = {
  key: 6,
  class: "form-group mb-3"
}
const _hoisted_19 = {
  for: "lastName",
  class: "form-label"
}
const _hoisted_20 = {
  key: 7,
  class: "form-group mb-3"
}
const _hoisted_21 = {
  for: "userName",
  class: "form-label"
}
const _hoisted_22 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_23 = {
  key: 8,
  class: "form-group mb-3"
}
const _hoisted_24 = {
  for: "password",
  class: "form-label"
}
const _hoisted_25 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_26 = {
  key: 9,
  class: "form-group mb-3"
}
const _hoisted_27 = {
  for: "passwordConfirmation",
  class: "form-label"
}
const _hoisted_28 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_29 = {
  key: 10,
  class: "form-group mb-3"
}
const _hoisted_30 = {
  for: "email",
  class: "form-label"
}
const _hoisted_31 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_32 = {
  key: 11,
  class: "form-group mb-3"
}
const _hoisted_33 = {
  for: "securityQuestion",
  class: "form-label"
}
const _hoisted_34 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_35 = {
  key: 12,
  class: "form-group mb-3"
}
const _hoisted_36 = {
  for: "securityAnswer",
  class: "form-label"
}
const _hoisted_37 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_38 = {
  key: 13,
  class: "form-group mt-4"
}
const _hoisted_39 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToolTip = _resolveComponent("ToolTip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isFormInvalid)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "alert alert-danger",
          innerHTML: _ctx.validationMsg
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.accountCreated)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
      : _createCommentVNode("", true),
    (_ctx.step === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("label", _hoisted_7, [
            _createTextVNode("SSN or Member ID "),
            _createVNode(_component_ToolTip, { tooltipText: "Enter your SSN or member ID. If your employer uses an alternative identifier, please enter your employer identifier." })
          ]),
          _withDirectives(_createElementVNode("input", {
            maxlength: "15",
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.ssn) = $event)),
            onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hideErrors('ssn'))),
            onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isSubmitDisabled = false)),
            id: "ssn",
            class: _normalizeClass(["form-control", _ctx.v$.user.ssn.$error ? 'is-invalid' : 'input-text'])
          }, null, 34), [
            [_vModelText, _ctx.user.ssn]
          ]),
          (_ctx.v$.user.ssn.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (_ctx.v$.user.ssn.$invalid)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass({ 'is-invalid': _ctx.v$.user.ssn.$error })
                    }, " Please enter a valid Member ID or SSN ", 2))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.step === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("label", _hoisted_10, [
            _createTextVNode("Zip Code "),
            _createVNode(_component_ToolTip, { tooltipText: "Enter your Zip Code." })
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.user.zip) = $event)),
            onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.hideErrors('zip'))),
            onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isSubmitDisabled = false)),
            id: "zip",
            class: _normalizeClass(["form-control", _ctx.v$.user.zip.$error ? 'is-invalid' : 'input-text'])
          }, null, 34), [
            [_vModelText, _ctx.user.zip]
          ]),
          (_ctx.v$.user.zip.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (_ctx.v$.user.zip.$invalid)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass({ 'is-invalid': _ctx.v$.user.zip.$error })
                    }, " Please enter a valid zip code ", 2))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.step === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("label", _hoisted_13, [
            _createTextVNode("Date Of Birth"),
            _createVNode(_component_ToolTip, { tooltipText: "Enter your date of birth." })
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "date",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.user.dob) = $event)),
            onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.v$.user.dob.$touch())),
            class: _normalizeClass({
        'is-invalid': _ctx.v$.user.dob.$error,
        'form-control': true,
      })
          }, null, 34), [
            [_vModelText, _ctx.user.dob]
          ]),
          (_ctx.v$.user.dob.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                (_ctx.v$.user.dob.required)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass({ 'is-invalid': _ctx.v$.user.dob.$error })
                    }, " Please enter a valid Date of Birth between 1/1/1753 and " + _toDisplayString(new Date().toLocaleDateString()), 3))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.step === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("label", _hoisted_16, [
            _createTextVNode("Last Name "),
            _createVNode(_component_ToolTip, { tooltipText: "Enter your last name." })
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.user.lastName) = $event)),
            onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.hideErrors('lastName'))),
            onBlur: _cache[10] || (_cache[10] = ($event: any) => (_ctx.isSubmitDisabled = false)),
            id: "lastName",
            class: _normalizeClass(["form-control", _ctx.v$.user.lastName.$error ? 'is-invalid' : 'input-text'])
          }, null, 34), [
            [_vModelText, _ctx.user.lastName]
          ]),
          (_ctx.v$.user.lastName.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                (_ctx.v$.user.lastName.$invalid)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass({ 'is-invalid': _ctx.v$.user.lastName.$error })
                    }, " Please enter a valid last name ", 2))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.step === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("label", _hoisted_19, [
            _createTextVNode("Name "),
            _createVNode(_component_ToolTip, { tooltipText: "This is the name attached to the account that was found." })
          ]),
          _withDirectives(_createElementVNode("input", {
            disabled: "",
            type: "text",
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.user.fullName) = $event)),
            onInput: _cache[12] || (_cache[12] = ($event: any) => (_ctx.hideErrors('fullName'))),
            onBlur: _cache[13] || (_cache[13] = ($event: any) => (_ctx.isSubmitDisabled = false)),
            id: "fullName",
            class: "form-control input-text"
          }, null, 544), [
            [_vModelText, _ctx.user.fullName]
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.step === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createElementVNode("label", _hoisted_21, [
            _createTextVNode("UserName"),
            _createVNode(_component_ToolTip, { tooltipText: "Enter a username for your account." })
          ]),
          _withDirectives(_createElementVNode("input", {
            maxlength: "18",
            type: "text",
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.user.userName) = $event)),
            onInput: _cache[15] || (_cache[15] = ($event: any) => (_ctx.hideErrors('userName'))),
            onBlur: _cache[16] || (_cache[16] = ($event: any) => (_ctx.isSubmitDisabled = false)),
            id: "userName",
            class: _normalizeClass(["form-control", _ctx.v$.user.userName.$error ? 'is-invalid' : 'input-text'])
          }, null, 34), [
            [_vModelText, _ctx.user.userName]
          ]),
          (_ctx.v$.user.userName.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                (_ctx.v$.user.userName.$invalid)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass({ 'is-invalid': _ctx.v$.user.userName.$error })
                    }, " Please enter a valid user name ", 2))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.step === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("label", _hoisted_24, [
            _createTextVNode("Password"),
            _createVNode(_component_ToolTip, { tooltipText: "Enter a password for your account.<p>Password Requirements</p>\n                                                <ul>\n                                                    <li>Must be at least 10 characters but no longer than 128 characters</li>\n                                                    <li>Must not contain your username</li>\n                                                    <li>Must contain at least three of the following\n                                                        <ul>\n                                                            <li>Uppercase Letters</li>\n                                                            <li>Lowercase Letters</li>\n                                                            <li>Numbers</li>\n                                                            <li>Special Characters($&+,:;=?@#|.^*()%!-).</li>\n                                                        </ul>\n                                                    </li>\n                                                </ul>" })
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "password",
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.user.password) = $event)),
            onInput: _cache[18] || (_cache[18] = ($event: any) => (_ctx.hideErrors('password'))),
            onBlur: _cache[19] || (_cache[19] = ($event: any) => (_ctx.isSubmitDisabled = false)),
            id: "password",
            class: _normalizeClass(["form-control", _ctx.v$.user.password.$error ? 'is-invalid' : 'input-text'])
          }, null, 34), [
            [_vModelText, _ctx.user.password]
          ]),
          (_ctx.v$.user.password.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                (_ctx.v$.user.password.$invalid)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass({ 'is-invalid': _ctx.v$.user.password.$error })
                    }, _toDisplayString(_ctx.v$.user.password.$silentErrors[0].$message), 3))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.step === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _createElementVNode("label", _hoisted_27, [
            _createTextVNode("Confirm Password"),
            _createVNode(_component_ToolTip, { tooltipText: "Confirm the password you entered previously" })
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "password",
            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.user.passwordConfirmation) = $event)),
            onInput: _cache[21] || (_cache[21] = ($event: any) => (_ctx.hideErrors('passwordConfirmation'))),
            onBlur: _cache[22] || (_cache[22] = ($event: any) => (_ctx.isSubmitDisabled = false)),
            id: "passwordConfirmation",
            class: _normalizeClass(["form-control", _ctx.v$.user.passwordConfirmation.$error ? 'is-invalid' : 'input-text'])
          }, null, 34), [
            [_vModelText, _ctx.user.passwordConfirmation]
          ]),
          (_ctx.v$.user.passwordConfirmation.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                (_ctx.v$.user.passwordConfirmation.$invalid)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass({ 'is-invalid': _ctx.v$.user.passwordConfirmation.$error })
                    }, _toDisplayString(_ctx.v$.user.passwordConfirmation.$silentErrors[0].$message), 3))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.step === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
          _createElementVNode("label", _hoisted_30, [
            _createTextVNode("E-mail Address"),
            _createVNode(_component_ToolTip, { tooltipText: "Enter an email address for your account." })
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "email",
            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.user.email) = $event)),
            onInput: _cache[24] || (_cache[24] = ($event: any) => (_ctx.hideErrors('email'))),
            onBlur: _cache[25] || (_cache[25] = ($event: any) => (_ctx.isSubmitDisabled = false)),
            id: "email",
            class: _normalizeClass(["form-control", _ctx.v$.user.email.$error ? 'is-invalid' : 'input-text'])
          }, null, 34), [
            [_vModelText, _ctx.user.email]
          ]),
          (_ctx.v$.user.email.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                (_ctx.v$.user.email.$invalid)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass({ 'is-invalid': _ctx.v$.user.email.$error })
                    }, " Please enter a valid e-mail address ", 2))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.step === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
          _createElementVNode("label", _hoisted_33, [
            _createTextVNode("Security Question"),
            _createVNode(_component_ToolTip, { tooltipText: "Enter an security question for your account." })
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.user.securityQuestion) = $event)),
            onInput: _cache[27] || (_cache[27] = ($event: any) => (_ctx.hideErrors('securityQuestion'))),
            onBlur: _cache[28] || (_cache[28] = ($event: any) => (_ctx.isSubmitDisabled = false)),
            id: "securityQuestion",
            class: _normalizeClass(["form-control", _ctx.v$.user.securityQuestion.$error ? 'is-invalid' : 'input-text'])
          }, null, 34), [
            [_vModelText, _ctx.user.securityQuestion]
          ]),
          (_ctx.v$.user.securityQuestion.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                (_ctx.v$.user.securityQuestion.$invalid)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass({ 'is-invalid': _ctx.v$.user.securityQuestion.$error })
                    }, " Please enter a valid security question ", 2))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.step === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
          _createElementVNode("label", _hoisted_36, [
            _createTextVNode("Security Answer"),
            _createVNode(_component_ToolTip, { tooltipText: "Enter an answer to your security question for your account." })
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.user.securityAnswer) = $event)),
            onInput: _cache[30] || (_cache[30] = ($event: any) => (_ctx.hideErrors('securityAnswer'))),
            onBlur: _cache[31] || (_cache[31] = ($event: any) => (_ctx.isSubmitDisabled = false)),
            id: "securityAnswer",
            class: _normalizeClass(["form-control", _ctx.v$.user.securityAnswer.$error ? 'is-invalid' : 'input-text'])
          }, null, 34), [
            [_vModelText, _ctx.user.securityAnswer]
          ]),
          (_ctx.v$.user.securityAnswer.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                (_ctx.v$.user.securityAnswer.$invalid)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass({ 'is-invalid': _ctx.v$.user.securityAnswer.$error })
                    }, " Please enter a valid security question answer ", 2))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.step === 1 || _ctx.step === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
          (_ctx.step === 2)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                name: "backBtn",
                class: "btn back-btn btn-primary w-20",
                onClick: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.backButtonHandler && _ctx.backButtonHandler(...args)))
              }, " BACK "))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            disabled: _ctx.v$.user.$invalid || _ctx.isSubmitDisabled,
            class: _normalizeClass(["btn", [_ctx.buttonDesign()]]),
            id: "button-continue",
            type: "submit",
            onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.handleSubmit()))
          }, " CONTINUE ", 10, _hoisted_39)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}